{
  "rampsPresenter": {
    "title": "Ramps – {{fboName}}",
    "stats": {
      "totalRamps": "Total Ramps",
      "totalAircraft": "Total Aircraft on Ramps"
    },
    "columns": {
      "rampName": "Ramp Name",
      "currentAircraft": "Current Aircraft",
      "actions": "Actions"
    },
    "tooltips": {
      "aircraftCount": "# of aircraft on the ramp"
    },
    "emptyState": {
      "title": "No Ramps Yet",
      "description": "Create your first ramp to start managing aircraft parking and scheduling."
    },
    "rampRow": {
      "buttons": {
        "currentRamp": "Current Ramp",
        "rampSchedule": "Ramp Schedule",
        "editTenants": "Edit Tie Down Tenants"
      }
    }
  }
}
